import { Link, useLocation } from "react-router-dom";
import { Home, Layers, Rocket, Image, ArrowLeft, Menu, X, Sun, Moon } from "lucide-react";
import { useState } from "react";
import { useTheme } from "@/contexts/ThemeContext";

const navLinks = [
  { to: "/interior-design-ai/dashboard", label: "Dashboard",    icon: Home },
  { to: "/interior-design-ai/pipeline1",  label: "Auto-Furnish", icon: Rocket },
  { to: "/interior-design-ai/pipeline2",  label: "Custom Assets",icon: Layers },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  return (
    <nav
      className="sticky top-0 z-50"
      style={{
        background: "var(--surface)",
        borderBottom: "1px solid var(--border-strong)",
        boxShadow: "var(--shadow-sm)",
      }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14">

          {/* Left: back + logo */}
          <div className="flex items-center gap-3">
            <Link
              to="/marketplace"
              className="flex items-center gap-1.5 text-xs font-medium rounded-lg px-2.5 py-1.5 transition-all"
              style={{ color: "var(--text-secondary)", border: "1px solid var(--border-strong)", background: "var(--surface-soft)" }}
              title="Back to Marketplace"
            >
              <ArrowLeft className="w-3 h-3" />
              <span className="hidden sm:inline">Marketplace</span>
            </Link>

            <Link to="/interior-design-ai" className="flex items-center gap-2 font-semibold">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, var(--orange), var(--orange-light))" }}
              >
                <Image className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold" style={{ fontFamily: "'Outfit', sans-serif", color: "var(--text-primary)" }}>
                InteriorAI
              </span>
            </Link>
          </div>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map(({ to, label, icon: Icon }) => {
              const active = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all"
                  style={{
                    color: active ? "var(--orange)" : "var(--text-secondary)",
                    background: active ? "var(--orange-pale)" : "transparent",
                  }}
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </Link>
              );
            })}

            <div className="h-5 w-px mx-1" style={{ background: "var(--border-strong)" }} />

            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg transition-all"
              style={{ color: "var(--text-secondary)" }}
              title="Toggle theme"
            >
              {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
          </div>

          {/* Mobile */}
          <div className="md:hidden flex items-center gap-1">
            <button onClick={toggleTheme} className="p-2 rounded-lg" style={{ color: "var(--text-secondary)" }}>
              {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            <button onClick={() => setMobileOpen(!mobileOpen)} className="p-2 rounded-lg" style={{ color: "var(--text-secondary)" }}>
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden pb-4" style={{ borderTop: "1px solid var(--border)" }}>
            <Link to="/marketplace" onClick={() => setMobileOpen(false)}>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm mt-2" style={{ color: "var(--text-secondary)" }}>
                <ArrowLeft className="w-4 h-4" /> Back to Marketplace
              </div>
            </Link>
            {navLinks.map(({ to, label, icon: Icon }) => (
              <Link key={to} to={to} onClick={() => setMobileOpen(false)}>
                <div
                  className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium"
                  style={{
                    color: location.pathname === to ? "var(--orange)" : "var(--text-secondary)",
                    background: location.pathname === to ? "var(--orange-pale)" : "transparent",
                  }}
                >
                  <Icon className="w-4 h-4" /> {label}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
